import React from 'react';
import Icon from '../../../components/AppIcon';

const PartnerBenefits = () => {
  const benefits = [
    {
      icon: 'Palette',
      title: 'White-Label Platform',
      description: 'Volledig aanpasbare branding voor uw klanten',
      color: 'var(--color-primary)',
    },
    {
      icon: 'Users',
      title: 'Multi-Tenant Beheer',
      description: 'Beheer meerdere klantportfolios efficiënt',
      color: 'var(--color-secondary)',
    },
    {
      icon: 'BarChart3',
      title: 'Revenue Analytics',
      description: 'Gedetailleerde omzet en performance metrics',
      color: 'var(--color-success)',
    },
    {
      icon: 'Code',
      title: 'API Integratie',
      description: 'Volledige API toegang voor custom integraties',
      color: 'var(--color-primary)',
    },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h3 className="text-lg font-heading font-semibold text-foreground mb-4">
        Partner Voordelen
      </h3>
      <div className="space-y-4">
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={benefit?.icon} size={20} color={benefit?.color} />
            </div>
            <div>
              <h4 className="text-sm font-heading font-medium text-foreground mb-1">
                {benefit?.title}
              </h4>
              <p className="text-sm font-body text-muted-foreground">
                {benefit?.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-lg border border-primary/20">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Zap" size={20} color="var(--color-primary)" />
          <span className="text-sm font-heading font-semibold text-foreground">
            Premium Partner Tier
          </span>
        </div>
        <p className="text-sm font-body text-muted-foreground">
          Toegang tot exclusieve features en priority support voor enterprise partners
        </p>
      </div>
    </div>
  );
};

export default PartnerBenefits;